Vue.component('ack-navbar-item', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-navbar-item',
	mounted() {
		//window.addEventListener('scroll', this.handleScroll)
	},
	beforeDestroy() {
		//window.removeEventListener('scroll', this.handleScroll)
	},
	props: {
		menuItemObject: {
			type: Object,
		},
		mainNavBarIconsHidden: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...Vuex.mapGetters('localization', ['countryCode', 'isUS_CA']),
		storeAvailable() {
			return this.$parent.storeAvailable;
		},
		menuItemsWithAvailability() {
			return this.menuItemObject.items.filter((m) => {
				let item = m;

				if (item.onlyIfStoreAvailable == true) {
					if (this.storeAvailable) {
						item.isAvailable = true;
					} else {
						item.isAvailable = false;
					}
				} else {
					item.isAvailable = true;
				}

				if (item.isAvailable && item.hideItemInCountries) {
					let country = item.hideItemInCountries.find((m) => {
						return m.toUpperCase() == this.countryCode.toUpperCase();
					});

					if (country) {
						item.isAvailable = false;
					}
				}

				return item.isAvailable;
			});
		},

		navToggleIconName() {
			return this.isNavActive ? 'close-outline' : 'menu-outline';
		},

		menuSubItemsByGroup() {
			let originalList = this.menuItemObject.items;
			let finalList = [];

			if (this.menuItemObject.hasGroups === true) {
				for (let index = 0; index < originalList.length; index++) {
					const element = originalList[index];

					let item = element;
					if (item.onlyIfStoreAvailable == true) {
						if (this.storeAvailable) {
							item.isAvailable = true;
						} else {
							item.isAvailable = false;
						}
					} else {
						item.isAvailable = true;
					}

					if (Array.isArray(finalList[element.itemGroup])) {
						finalList[element.itemGroup].push(item);
					} else {
						finalList[element.itemGroup] = [];
						finalList[element.itemGroup].push(item);
					}
				}
			}

			return finalList;
		},
	},
	data() {
		return {
			menuOpen: false,
			isVisible: true,
			lastScrollTop: 0,
			//mainNavBarIconsHidden: false
		};
	},
	methods: {
		...Vuex.mapActions(['toSnakeLowerCaseValidSelector']),
		toggleMenu() {
			this.menuOpen = !this.menuOpen;
		},
	},
	beforeDestroy() {
		//window.removeEventListener('scroll', this.handleScroll)
	},
	watch: {},
});
